// Utilidades de fechas y formato compartidas por las pantallas de Inventarios.

// Date → YYYY-MM-DD en hora LOCAL (el valor que usa <input type="date">). Sustituye a `fechaLocal`.
export const aISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const haceDias = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
};

// Extrae YYYY-MM-DD del inicio de un string; "" si no coincide
export const isoDia = (v) => (typeof v === "string" ? v.match(/^(\d{4}-\d{2}-\d{2})/)?.[1] : "") || "";

// Número con separadores colombianos. Por defecto 2 decimales; Invent usa 3 (el máximo por defecto de toLocaleString).
export const fmt = (n, maxDecimales = 2) =>
  Number(n ?? 0).toLocaleString("es-CO", { maximumFractionDigits: maxDecimales });

// DD/MM/YYYY; "—" si no hay valor; el texto original si no es una fecha válida
export const fmtFecha = (v) => {
  if (!v) return "—";
  const dia = isoDia(v);
  if (dia) return dia.split("-").reverse().join("/");
  const f = new Date(v);
  return Number.isNaN(f.getTime()) ? String(v) : f.toLocaleDateString("es-CO");
};

// Comparador para ordenar: números por resta, texto con localeCompare numérico en español
export const comparar = (a, b) =>
  typeof a === "number" && typeof b === "number"
    ? a - b
    : String(a ?? "").localeCompare(String(b ?? ""), "es", { numeric: true });